var GRID_ALIGNMENT = {
  START: 'nva-slidercard__content--grid-start',
  CENTER: 'nva-slidercard__content--grid-center',
  END: 'nva-slidercard__content--grid-end'
};
var ALIGNMENT = {
  LEFT: 'nva-slidercard__content--left',
  CENTER: 'nva-slidercard__content--center',
  RIGHT: 'nva-slidercard__content--right'
};
var VERTICAL_ALIGNMENT = {
  SPACE_BETWEEN: 'nva-slidercard__content--y-space-between',
  TOP: 'nva-slidercard__content--y-top',
  BOTTOM: 'nva-slidercard__content--y-bottom',
  CENTER: 'nva-slidercard__content--y-center'
};
export default {
  GRID_ALIGNMENT: GRID_ALIGNMENT,
  ALIGNMENT: ALIGNMENT,
  VERTICAL_ALIGNMENT: VERTICAL_ALIGNMENT
};